import { useState } from "react";
import PropTypes from "prop-types";
import { MapPin, Loader2, ChevronDown, ChevronUp } from "lucide-react";
import { CARD_TITLE, TABLE_COLUMNS } from "./constants";
import { getUtilizationClass } from "./utils";

const TOP_SITES_LIMIT = 5;

export default function TopSites({ sites, loading }) {
  const [showAll, setShowAll] = useState(false);

  const displayedSites = showAll ? sites : sites.slice(0, TOP_SITES_LIMIT);
  const hasMoreSites = sites.length > TOP_SITES_LIMIT;

  return (
    <div className="sites-card" style={{ marginBottom: 24 }}>
      <div className="sites-card__header">
        <span className="sites-card__title">{CARD_TITLE}</span>
        {loading ? <Loader2 size={16} color="#6b7280" className="spin" /> : <MapPin size={16} color="#6b7280" />}
      </div>
      {loading ? (
        <div style={{ padding: "24px 0", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>
          Loading site utilization data...
        </div>
      ) : sites.length === 0 ? (
        <div style={{ padding: "24px 0", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>
          No site data available
        </div>
      ) : (
        <>
          <table className="sites-table">
            <thead>
              <tr>
                {TABLE_COLUMNS.map((col, i) => (
                  <th
                    key={col.key}
                    style={{
                      textAlign: i === 0 ? "left" : i === TABLE_COLUMNS.length - 1 ? "right" : "center",
                    }}
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {displayedSites.map(site => (
                <tr key={site.name}>
                  <td style={{ fontWeight: 600 }}>{site.name}</td>
                  <td style={{ textAlign: "center" }}>{site.chargers}</td>
                  <td style={{ textAlign: "center" }}>{site.sessions}</td>
                  <td style={{ textAlign: "center" }}>{site.energy.toLocaleString()}</td>
                  <td style={{ textAlign: "center" }}>{site.utilizationTime || "—"}</td>
                  <td style={{ textAlign: "right" }}>
                    <div className="utilization-bar">
                      <div className="utilization-bar__track">
                        <div
                          className={`utilization-bar__fill ${getUtilizationClass(site.utilization)}`}
                          style={{ width: `${site.utilization}%` }}
                        />
                      </div>
                      <span className="utilization-bar__label">{site.utilization}%</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {hasMoreSites && (
            <button type="button" className="sites-card__view-more" onClick={() => setShowAll(!showAll)}>
              {showAll ? (
                <>
                  <ChevronUp size={14} />
                  Show Less
                </>
              ) : (
                <>
                  <ChevronDown size={14} />
                  View More ({sites.length - TOP_SITES_LIMIT} more)
                </>
              )}
            </button>
          )}
        </>
      )}
    </div>
  );
}

TopSites.propTypes = {
  sites: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      chargers: PropTypes.number.isRequired,
      sessions: PropTypes.number.isRequired,
      energy: PropTypes.number.isRequired,
      utilizationTime: PropTypes.string,
      utilization: PropTypes.number.isRequired,
    })
  ),
  loading: PropTypes.bool,
};

TopSites.defaultProps = {
  sites: [],
  loading: false,
};
